import { Trans } from '@lingui/macro'
import { TableDataContainer } from 'components/Table'
import { PAGE_SIZE } from 'graphql/data/TopTokens'
import { GridContainer, NoTokensState } from 'pages/Liquidity/Table'
import { AlertTriangle } from 'react-feather'

import { HeaderRow, LoadedRow, LoadingRow } from './HistoryRow'

const LoadingRows = ({ rowCount }: { rowCount: number }) => (
  <>
    {Array(rowCount)
      .fill(null)
      .map((_, index) => {
        return <LoadingRow key={index} first={index === 0} last={index === rowCount - 1} />
      })}
  </>
)

function LoadingTokenTable({ rowCount = PAGE_SIZE }: { rowCount?: number }) {
  return (
    <GridContainer>
      <HeaderRow />
      <TableDataContainer>
        <LoadingRows rowCount={rowCount} />
      </TableDataContainer>
    </GridContainer>
  )
}

export default function Table() {
  const loadingHistorys = false
  const historyList = [{}, {}]
  /* loading and error state */
  if (loadingHistorys && !historyList) {
    return <LoadingTokenTable rowCount={5} />
  } else if (!historyList) {
    return (
      <NoTokensState
        thRow={<HeaderRow />}
        message={
          <>
            <AlertTriangle size={16} />
            <Trans>An error occurred loading historyList. Please try again.</Trans>
          </>
        }
      />
    )
  } else if (historyList?.length === 0) {
    return <NoTokensState thRow={<HeaderRow />} message={<Trans>No historyList found</Trans>} />
  } else {
    return (
      <>
        <HeaderRow />
        <TableDataContainer>
          {historyList.map((history, index) => (
            <LoadedRow key={index} historyListIndex={index} historyListLength={historyList.length} history={history} />
          ))}
        </TableDataContainer>
      </>
    )
  }
}
